// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-error-page {
  min-height: 600px;
  margin: 0px auto;
  width: auto;
  max-width: 560px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.error-title {
  max-width: 529px; 
  font-family: Roboto;
  font-size: 38px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #4b4b62;
  margin-bottom: 16px;
}

.error-subtitle {
  max-width: 568px; 
  font-family: Roboto;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.31;
  letter-spacing: normal;
  text-align: center;
  color: #4b4b62;
  margin-bottom: 24px;
}
svg {
  /* margin-bottom: 16px; */
}


.full-torradeira {
   
}
.torradeira {
}

.pao-atras {
  animation: leftright 1s alternate infinite;
  transform-origin: center;
}
.pao-frente {
    animation: leftright 1s 0.3s alternate infinite;
  transform-origin: center;
}

.olho-esq {
  
    animation: sad 2s alternate infinite;
  transform-origin: center;
}

.olho-dir {
  
    animation: sad 2s alternate infinite;
  transform-origin: center;
}
.boca {
    animation: sad 2s alternate infinite;
  transform-origin: center;
}
.raios {
  animation: flicker-4 4s linear infinite both;
}
.tomada {
	 animation: vibrate-1 3s linear infinite both;
}
.fio-500 {
	 animation: vibrate-1 3s linear infinite both;
}
.fio{
	 animation: vibrate-1 3s linear infinite both;
}

@keyframes scales {
  from {
    transform: scale(0.98);
  }
  to {
    transform: scale(1);
  }
}
@keyframes flicker-4 {
  0%,
  100% {
    opacity: 1;
  }
  31.98% {
    opacity: 1;
  }
  32% {
    opacity: 0;
  }
  32.8% {
    opacity: 0;
  }
  32.82% {
    opacity: 1;
  }
  34.98% {
    opacity: 1;
  }
  35% {
    opacity: 0;
  }
  35.7% {
    opacity: 0;
  }
  35.72% {
    opacity: 1;
  }
  36.98% {
    opacity: 1;
  }
  37% {
    opacity: 0;
  }
  37.6% {
    opacity: 0;
  }
  37.62% {
    opacity: 1;
  }
  67.98% {
    opacity: 1;
  }
  68% {
    opacity: 0;
  }
  68.4% {
    opacity: 0;
  }
  68.42% {
    opacity: 1;
  }
  95.98% {
    opacity: 1;
  }
  96% {
    opacity: 0;
  }
  96.7% {
    opacity: 0;
  }
  96.72% {
    opacity: 1;
  }
  98.98% {
    opacity: 1;
  }
  99% {
    opacity: 0;
  }
  99.6% {
    opacity: 0;
  }
  99.62% {
    opacity: 1;
  }
}
@keyframes vibrate-1 {
  0% {
    transform: translate(0);
  }
  20% {
    transform: translate(-2px, 2px);
  }
  40% {
    transform: translate(-2px, -2px);
  }
  60% {
    transform: translate(2px, 2px);
  }
  80% {
    transform: translate(2px, -2px);
  }
  100% {
    transform: translate(0);
  }
}



/* ----------------------------------------------
 * Generated by Animista on 2020-4-1 15:42:45
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info. 
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation wobble-ver-right
 * ----------------------------------------
 */
 

@keyframes sad {
  0% {
    transform: rotateX(0deg) rotateY(0deg);
  }
  100% {
    transform: rotateX(10deg)  rotateY(5deg);
  }
}

@keyframes leftright{
  
  0%{
    transform: rotateZ( 0deg)
  }
   100%{
    transform: rotateZ( -15deg)
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Errors Handling/Error 500/InternalServer.css"],"names":[],"mappings":"AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,yBAAyB;AAC3B;;;AAGA;;AAEA;AACA;AACA;;AAEA;EACE,0CAA0C;EAC1C,wBAAwB;AAC1B;AACA;IACI,+CAA+C;EACjD,wBAAwB;AAC1B;;AAEA;;IAEI,oCAAoC;EACtC,wBAAwB;AAC1B;;AAEA;;IAEI,oCAAoC;EACtC,wBAAwB;AAC1B;AACA;IACI,oCAAoC;EACtC,wBAAwB;AAC1B;AACA;EAEE,4CAA4C;AAC9C;AACA;EAES,4CAA4C;AACrD;AACA;EAES,4CAA4C;AACrD;AACA;EAES,4CAA4C;AACrD;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,mBAAmB;EACrB;AACF;AAiFA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AA6BA;EACE;IAEU,uBAAuB;EACjC;EACA;IAEU,+BAA+B;EACzC;EACA;IAEU,gCAAgC;EAC1C;EACA;IAEU,8BAA8B;EACxC;EACA;IAEU,+BAA+B;EACzC;EACA;IAEU,uBAAuB;EACjC;AACF;;;;AAIA;;;;;mDAKmD;;AAEnD;;;;EAIE;;;AAgCF;EACE;IACE,sCAAsC;EACxC;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA;;EAEE;IACE;EACF;GACC;IACC;EACF;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Roboto&display=swap');\n.main-error-page {\n  min-height: 600px;\n  margin: 0px auto;\n  width: auto;\n  max-width: 560px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n.error-title {\n  max-width: 529px; \n  font-family: Roboto;\n  font-size: 38px;\n  font-weight: bold;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  text-align: center;\n  color: #4b4b62;\n  margin-bottom: 16px;\n}\n\n.error-subtitle {\n  max-width: 568px; \n  font-family: Roboto;\n  font-size: 16px;\n  font-weight: normal;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: 1.31;\n  letter-spacing: normal;\n  text-align: center;\n  color: #4b4b62;\n  margin-bottom: 24px;\n}\nsvg {\n  /* margin-bottom: 16px; */\n}\n\n\n.full-torradeira {\n   \n}\n.torradeira {\n}\n\n.pao-atras {\n  animation: leftright 1s alternate infinite;\n  transform-origin: center;\n}\n.pao-frente {\n    animation: leftright 1s 0.3s alternate infinite;\n  transform-origin: center;\n}\n\n.olho-esq {\n  \n    animation: sad 2s alternate infinite;\n  transform-origin: center;\n}\n\n.olho-dir {\n  \n    animation: sad 2s alternate infinite;\n  transform-origin: center;\n}\n.boca {\n    animation: sad 2s alternate infinite;\n  transform-origin: center;\n}\n.raios {\n  -webkit-animation: flicker-4 4s linear infinite both;\n  animation: flicker-4 4s linear infinite both;\n}\n.tomada {\n  -webkit-animation: vibrate-1 3s linear infinite both;\n\t        animation: vibrate-1 3s linear infinite both;\n}\n.fio-500 {\n  -webkit-animation: vibrate-1 3s linear infinite both;\n\t        animation: vibrate-1 3s linear infinite both;\n}\n.fio{ \n  -webkit-animation: vibrate-1 3s linear infinite both;\n\t        animation: vibrate-1 3s linear infinite both;\n}\n\n@keyframes scales {\n  from {\n    transform: scale(0.98);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n\n\n@-webkit-keyframes flicker-4 {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  31.98% {\n    opacity: 1;\n  }\n  32% {\n    opacity: 0;\n  }\n  32.8% {\n    opacity: 0;\n  }\n  32.82% {\n    opacity: 1;\n  }\n  34.98% {\n    opacity: 1;\n  }\n  35% {\n    opacity: 0;\n  }\n  35.7% {\n    opacity: 0;\n  }\n  35.72% {\n    opacity: 1;\n  }\n  36.98% {\n    opacity: 1;\n  }\n  37% {\n    opacity: 0;\n  }\n  37.6% {\n    opacity: 0;\n  }\n  37.62% {\n    opacity: 1;\n  }\n  67.98% {\n    opacity: 1;\n  }\n  68% {\n    opacity: 0;\n  }\n  68.4% {\n    opacity: 0;\n  }\n  68.42% {\n    opacity: 1;\n  }\n  95.98% {\n    opacity: 1;\n  }\n  96% {\n    opacity: 0;\n  }\n  96.7% {\n    opacity: 0;\n  }\n  96.72% {\n    opacity: 1;\n  }\n  98.98% {\n    opacity: 1;\n  }\n  99% {\n    opacity: 0;\n  }\n  99.6% {\n    opacity: 0;\n  }\n  99.62% {\n    opacity: 1;\n  }\n}\n@keyframes flicker-4 {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  31.98% {\n    opacity: 1;\n  }\n  32% {\n    opacity: 0;\n  }\n  32.8% {\n    opacity: 0;\n  }\n  32.82% {\n    opacity: 1;\n  }\n  34.98% {\n    opacity: 1;\n  }\n  35% {\n    opacity: 0;\n  }\n  35.7% {\n    opacity: 0;\n  }\n  35.72% {\n    opacity: 1;\n  }\n  36.98% {\n    opacity: 1;\n  }\n  37% {\n    opacity: 0;\n  }\n  37.6% {\n    opacity: 0;\n  }\n  37.62% {\n    opacity: 1;\n  }\n  67.98% {\n    opacity: 1;\n  }\n  68% {\n    opacity: 0;\n  }\n  68.4% {\n    opacity: 0;\n  }\n  68.42% {\n    opacity: 1;\n  }\n  95.98% {\n    opacity: 1;\n  }\n  96% {\n    opacity: 0;\n  }\n  96.7% {\n    opacity: 0;\n  }\n  96.72% {\n    opacity: 1;\n  }\n  98.98% {\n    opacity: 1;\n  }\n  99% {\n    opacity: 0;\n  }\n  99.6% {\n    opacity: 0;\n  }\n  99.62% {\n    opacity: 1;\n  }\n}\n\n\n@-webkit-keyframes vibrate-1 {\n  0% {\n    -webkit-transform: translate(0);\n            transform: translate(0);\n  }\n  20% {\n    -webkit-transform: translate(-2px, 2px);\n            transform: translate(-2px, 2px);\n  }\n  40% {\n    -webkit-transform: translate(-2px, -2px);\n            transform: translate(-2px, -2px);\n  }\n  60% {\n    -webkit-transform: translate(2px, 2px);\n            transform: translate(2px, 2px);\n  }\n  80% {\n    -webkit-transform: translate(2px, -2px);\n            transform: translate(2px, -2px);\n  }\n  100% {\n    -webkit-transform: translate(0);\n            transform: translate(0);\n  }\n}\n@keyframes vibrate-1 {\n  0% {\n    -webkit-transform: translate(0);\n            transform: translate(0);\n  }\n  20% {\n    -webkit-transform: translate(-2px, 2px);\n            transform: translate(-2px, 2px);\n  }\n  40% {\n    -webkit-transform: translate(-2px, -2px);\n            transform: translate(-2px, -2px);\n  }\n  60% {\n    -webkit-transform: translate(2px, 2px);\n            transform: translate(2px, 2px);\n  }\n  80% {\n    -webkit-transform: translate(2px, -2px);\n            transform: translate(2px, -2px);\n  }\n  100% {\n    -webkit-transform: translate(0);\n            transform: translate(0);\n  }\n}\n\n\n\n/* ----------------------------------------------\n * Generated by Animista on 2020-4-1 15:42:45\n * Licensed under FreeBSD License.\n * See http://animista.net/license for more info. \n * w: http://animista.net, t: @cssanimista\n * ---------------------------------------------- */\n\n/**\n * ----------------------------------------\n * animation wobble-ver-right\n * ----------------------------------------\n */\n@-webkit-keyframes wobble-ver-right {\n  0%,\n  100% {\n    -webkit-transform: translateY(0) rotate(0);\n            transform: translateY(0) rotate(0);\n    -webkit-transform-origin: 50% 50%;\n            transform-origin: 50% 50%;\n  }\n  15% {\n    -webkit-transform: translateY(-30px) rotate(6deg);\n            transform: translateY(-30px) rotate(6deg);\n  }\n  30% {\n    -webkit-transform: translateY(15px) rotate(-6deg);\n            transform: translateY(15px) rotate(-6deg);\n  }\n  45% {\n    -webkit-transform: translateY(-15px) rotate(3.6deg);\n            transform: translateY(-15px) rotate(3.6deg);\n  }\n  60% {\n    -webkit-transform: translateY(9px) rotate(-2.4deg);\n            transform: translateY(9px) rotate(-2.4deg);\n  }\n  75% {\n    -webkit-transform: translateY(-6px) rotate(1.2deg);\n            transform: translateY(-6px) rotate(1.2deg);\n  }\n}\n \n\n@keyframes sad {\n  0% {\n    transform: rotateX(0deg) rotateY(0deg);\n  }\n  100% {\n    transform: rotateX(10deg)  rotateY(5deg);\n  }\n}\n\n@keyframes leftright{\n  \n  0%{\n    transform: rotateZ( 0deg)\n  }\n   100%{\n    transform: rotateZ( -15deg)\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
